import React from 'react';
import { Tabs } from '@chakra-ui/react';
import type { ValueChangeDetails as TabsValueChangeDetails } from '@zag-js/tabs';

export type TabsPropTypes = {
  tabData: Array<{
    label: string;
    content: React.ReactElement;
    isActive?: boolean;
  }>;
  index?: number;
  onChange?: (_nextIndex: number) => void;
  isLazy?: boolean;
};

const AppTabs: React.FC<TabsPropTypes> = ({
  tabData,
  index = 0,
  onChange,
  isLazy,
}) => {
  const items = tabData.filter((item) => item.isActive);
  const safeIndex =
    items.length === 0 ? 0 : Math.min(Math.max(index, 0), items.length - 1);
  const strValue = String(safeIndex);

  return (
    <Tabs.Root
      value={strValue}
      onValueChange={(d: TabsValueChangeDetails) => onChange?.(Number(d.value))}
      lazyMount={Boolean(isLazy)}
      unmountOnExit={Boolean(isLazy)}
      variant="line"
      size="md"
      colorPalette="brand"
    >
      <Tabs.List
        w="100%"
        bg="transparent"
        borderColor="body2"
        overflowX="auto"
        overflowY="hidden"
      >
        {items.map((tab, i) => (
          <React.Fragment key={i}>
            <Tabs.Trigger
              value={String(i)}
              w={{ base: '100%', md: 'auto' }}
              minW="max-content"
              fontSize="md"
              color="body2"
              fontWeight="normal"
              textTransform="capitalize"
              px={{ base: 3, md: 4 }}
              py={3}
              _selected={{
                color: 'body',
                fontWeight: 'medium',
              }}
            >
              {tab.label}
            </Tabs.Trigger>
          </React.Fragment>
        ))}
      </Tabs.List>
      {items.map((tab, i) => (
        <React.Fragment key={i}>
          <Tabs.Content value={String(i)} p="0" borderColor="body2">
            {tab.content}
          </Tabs.Content>
        </React.Fragment>
      ))}
    </Tabs.Root>
  );
};

export default AppTabs;
